"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const routeContainers_1 = require("../../../comps/routeContainers");
const EditAdForm_1 = require("./EditAdForm");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
exports.AdsDetailRouter = ({ data }) => {
    const { history } = use_react_router_1.default();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: `/ads/${data.id}(/settings)?`, component: EditAdForm_1.EditAdForm, componentProps: {
                data,
                onDelete: () => {
                    history.push('/ads');
                },
            } }),
        react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: `/ads/${data.id}/emails`, component: EditAdForm_1.EditAdForm, componentProps: {
                data,
                onDelete: () => {
                    history.push('/ads');
                },
            } })));
};
//# sourceMappingURL=Router.js.map